export const ACTIONS_KASPI = {
  ADD_PRODUCTS: 'ADD_KASPI_PRODUCTS',
  CHANGE_PRODUCT: 'CHANGE_KASPI_PRODUCT',
  CHANGE_MARKET: 'CHANGE_KASPI_MARKET',
};

export const addKaspiProducts = data => ({
  type: ACTIONS_KASPI.ADD_PRODUCTS,
  data,
});

export const actionChangeKaspiProduct = (product = {}) => ({
  type: ACTIONS_KASPI.CHANGE_PRODUCT,
  product,
});

export const changeKaspiMarket = market => ({
  type: ACTIONS_KASPI.CHANGE_MARKET,
  market,
});